import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as FarmWeatherLocationActions from '../_actions/farmWeatherLocation';
import { FarmWeatherLocation } from '../_models/farmWeatherLocation';

export interface FarmWeatherLocationState extends EntityState<FarmWeatherLocation> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<FarmWeatherLocation> =
  createEntityAdapter<FarmWeatherLocation>();

const initialState: FarmWeatherLocationState = adapter.getInitialState({
  loading: false,
  error: null,
});

const farmWeatherLocationReducer = createReducer(
  initialState,

  on(FarmWeatherLocationActions.loadFarmWeatherLocations, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(FarmWeatherLocationActions.loadFarmWeatherLocationsSuccess, (state, { locations }) =>
    adapter.setAll(locations, { ...state, loading: false })
  ),

  on(FarmWeatherLocationActions.loadFarmWeatherLocationsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(FarmWeatherLocationActions.addFarmWeatherLocationSuccess, (state, { location }) =>
    adapter.addOne(location, state)
  ),

  on(FarmWeatherLocationActions.updateFarmWeatherLocationSuccess, (state, { location }) =>
    adapter.upsertOne(location, state)
  ),

  on(FarmWeatherLocationActions.deleteFarmWeatherLocationSuccess, (state, { location }) =>
    adapter.removeOne(location.id, state)
  ),

  on(
    FarmWeatherLocationActions.addFarmWeatherLocationFailure,
    FarmWeatherLocationActions.updateFarmWeatherLocationFailure,
    FarmWeatherLocationActions.deleteFarmWeatherLocationFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: FarmWeatherLocationState | undefined, action: Action) {
  return farmWeatherLocationReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
